// @ts-nocheck
import React, { memo } from 'react';
import { Grid } from '@material-ui/core';
import { Form, Formik } from 'formik';

import Button from '../../elements/Button';
import { BUTTON_COLOR, BUTTON_SIZE, BUTTON_TYPE, BUTTON_VARIANT } from '../../enum/formProps';

import './DialogForm.scss';

interface DialogFormProps<T> {
  initialValues: T;
  validationSchema: object;
  onSubmit: (values: T) => void;
  onClose: () => void;
  buttonActionLabel: string;
}

function component<T>(props: React.PropsWithChildren<DialogFormProps<T>>) {
  return (
    <Formik
      initialValues={props.initialValues}
      onSubmit={props.onSubmit}
      validationSchema={props.validationSchema}
      enableReinitialize={true}
      validateOnChange={false}
    >
      <Form noValidate className="DialogForm-Wrapper">
        {props.children}
        <Grid container spacing={0} className="DialogForm-Container">
          <Grid item lg={12}>
            <Button
              className="DialogForm-Save"
              text={props.buttonActionLabel}
              size={BUTTON_SIZE.LARGE}
              color={BUTTON_COLOR.PRIMARY}
              variant={BUTTON_VARIANT.CONTAINED}
              type={BUTTON_TYPE.SUBMIT}
            />
            <Button
              className="DialogForm-Close"
              text="button.close"
              size={BUTTON_SIZE.LARGE}
              color={BUTTON_COLOR.DEFAULT}
              variant={BUTTON_VARIANT.CONTAINED}
              type={BUTTON_TYPE.BUTTON}
              onClick={props.onClose}
            />
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
}

const DialogForm = memo(component) as typeof component;

export default DialogForm;
